module.exports = __webpack_public_path__ + "static/media/Weight-2.0b0f8922.png";